var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPagination)?_c('v-pagination',{staticClass:"custom",attrs:{"length":_vm.noOfPages},model:{value:(_vm.jobpageLocal),callback:function ($$v) {_vm.jobpageLocal=$$v},expression:"jobpageLocal"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }